import { ActionIcon, Flex, Group, Modal, SegmentedControl, Stack, Text } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import React, { useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { ConfirmDialog } from "../../../../components";
import { useAppSelector } from "../../../../hooks";
import {
  useDeleteProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdMutation,
  useDeleteProjectByProjectIdChecklistAndChecklistIdItemItemIdMutation,
} from "../../../../../openapi";
import "../checklistBoardApi.enhance";
import { selectChecklistModalViewModel } from "../checklistSelectors";
import ChecklistDetailsRefactored from "./ChecklistDetailsRefactored";
import ChecklistModalLogsRefactored from "./ChecklistModalLogsRefactored";

const ChecklistModalRefactored: React.FC = () => {
  const routerHistory = useHistory();
  const location = useLocation();
  const { checklistId } = useParams<{ checklistId: string }>();
  const checklistRowId = new URLSearchParams(location.search).get("id");
  const { checklist, checklistRow, editable, isItem, projectId } = useAppSelector((state) =>
    selectChecklistModalViewModel(state, checklistId, checklistRowId),
  );
  const [selectedTab, setSelectedTab] = useState("info");
  const [deleteItem] = useDeleteProjectByProjectIdChecklistAndChecklistIdItemItemIdMutation();
  const [deleteCategory] = useDeleteProjectByProjectIdChecklistAndChecklistIdCategoryCategoryIdMutation();

  const closeModal = () => {
    routerHistory.push(location.pathname);
  };

  if (checklist == null || checklistRow == null || checklistRowId == null) {
    return null;
  }

  return (
    <Modal
      opened
      onClose={closeModal}
      size="xl"
      withinPortal={true}
      title={
        <Text lineClamp={1} fz="md">
          {isItem === true
            ? `${checklistRow.rowId}: ${checklistRow.title}`
            : `${checklistRow.rowId}: ${checklistRow.originalCategory.title}`}
        </Text>
      }
    >
      <Stack gap="md">
        <Flex align="center" gap="md">
          <SegmentedControl
            color="mc-primary"
            value={selectedTab}
            onChange={setSelectedTab}
            data={[
              { label: "Info", value: "info" },
              { label: "Logg", value: "logs" },
            ]}
            fullWidth
            style={{ maxWidth: "14rem", width: "100%" }}
          />

          <Group justify="flex-end" style={{ flex: 1 }}>
            {editable && isItem === true && (
              <ConfirmDialog
                confirmCb={async () => {
                  await deleteItem({
                    projectId,
                    checklistId: checklist._id,
                    itemId: checklistRow._id,
                  }).unwrap();
                  closeModal();
                }}
                message="Vil du virkelig slette rad??"
                title="Slett rad"
              >
                <ActionIcon color="red" variant="light" aria-label="Slett rad">
                  <IconTrash />
                </ActionIcon>
              </ConfirmDialog>
            )}
            {editable && isItem === false && (
              <ConfirmDialog
                confirmCb={async () => {
                  await deleteCategory({
                    projectId,
                    checklistId: checklist._id,
                    categoryId: checklistRow._id,
                  }).unwrap();
                  closeModal();
                }}
                message="Vil du virkelig slette kategori og alle rader?"
                title="Fjern kategori"
              >
                <ActionIcon color="red" variant="light" aria-label="Fjern kategori">
                  <IconTrash />
                </ActionIcon>
              </ConfirmDialog>
            )}
          </Group>
        </Flex>

        <Stack gap="md">
          {selectedTab === "info" && <ChecklistDetailsRefactored />}
          {selectedTab === "logs" && <ChecklistModalLogsRefactored />}
        </Stack>
      </Stack>
    </Modal>
  );
};

export default ChecklistModalRefactored;
